import RadioTile from '@ramsey-design-system/radio-tile';
import { Field, useFormikContext } from 'formik';
import { CoverageCheckupState } from '../../../store/step';
import { FormikFormMultiField } from '../../shared/FormikFormMultiField';
import React, { ReactElement } from 'react';

interface InsuranceDetailsFormProps {
  name: keyof CoverageCheckupState;
}

function InsuranceDetailsForm({
  name,
}: InsuranceDetailsFormProps): ReactElement {
  const { values } = useFormikContext<CoverageCheckupState>();
  return (
    <FormikFormMultiField<CoverageCheckupState> name={name} as="fieldset">
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="Last 6 months"
        value="last_six_months"
        data-testid="last_six_months"
        checked={values[name] === 'last_six_months'}
        size="sm"
      />
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="Last 12 months"
        value="last_twelve_months"
        data-testid="last_twelve_months"
        checked={values[name] === 'last_twelve_months'}
        size="sm"
      />
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="Over a year ago"
        value="one_year_or_more"
        data-testid="one_year_or_more"
        checked={values[name] === 'one_year_or_more'}
        size="sm"
      />
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="I'm not sure"
        value="not_sure"
        data-testid="not_sure"
        checked={values[name] === 'not_sure'}
        size="sm"
      />
    </FormikFormMultiField>
  );
}

export { InsuranceDetailsForm };
